/**
 * WebMCP 游戏控制工具
 * 包含开始、暂停、重新开始等功能
 */
/* eslint-disable */
var states = require('../../control/states').default;
var store = require('../../store').default;
var t = require('../lang').t;

/**
 * 开始游戏
 */
function startGame() {
  var state = store.getState();

  // 检查是否已经在进行中
  if (state.get('cur') !== null && !state.get('reset')) {
    return { success: false, error: t('游戏已在进行中', 'Game already in progress') };
  }

  states.start();

  return {
    success: true,
    message: t('游戏已开始', 'Game started'),
  };
}

/**
 * 暂停/继续游戏
 */
function togglePause(pause) {
  var state = store.getState();

  // 检查锁定状态
  if (state.get('lock')) {
    return { success: false, error: t('游戏处于锁定状态', 'Game is locked') };
  }

  var cur = state.get('cur');
  if (cur === null) {
    return { success: false, error: t('没有活动游戏，无法暂停', 'No active game, cannot pause') };
  }

  var currentPause = state.get('pause');
  var newPause = pause !== undefined ? pause : !currentPause;

  states.pause(newPause);

  return {
    success: true,
    message: newPause ? t('游戏已暂停', 'Game paused') : t('游戏已继续', 'Game resumed'),
    isPaused: newPause,
  };
}

/**
 * 重新开始游戏
 */
function restartGame() {
  var state = store.getState();

  // 先结束当前游戏
  if (state.get('cur') !== null) {
    states.overStart();
  }

  // 短暂延迟后开始新游戏
  setTimeout(function() {
    states.overEnd();
    states.start();
  }, 150);

  return {
    success: true,
    message: t('游戏已重新开始', 'Game restarted'),
  };
}

/**
 * WebMCP 工具定义 - 开始游戏
 */
var startTool = {
  name: 'tetris_start',
  description: t('开始新游戏', 'Start a new game'),
  inputSchema: {
    type: 'object',
    properties: {},
  },
  execute: function() {
    var result = startGame();
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};

/**
 * WebMCP 工具定义 - 暂停/继续
 */
var pauseTool = {
  name: 'tetris_pause',
  description: t('暂停或继续游戏。不传参数则切换状态', 'Pause or resume the game. Toggle when no argument'),
  inputSchema: {
    type: 'object',
    properties: {
      pause: {
        type: 'boolean',
        description: t('true为暂停，false为继续，不传则切换状态', 'true=pause, false=resume, omit to toggle'),
      },
    },
  },
  execute: function(args) {
    args = args || {};
    var result = togglePause(args.pause);
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};

/**
 * WebMCP 工具定义 - 重新开始
 */
var restartTool = {
  name: 'tetris_restart',
  description: t('重新开始游戏（重置所有状态）', 'Restart the game (reset all state)'),
  inputSchema: {
    type: 'object',
    properties: {},
  },
  execute: function() {
    var result = restartGame();
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};

module.exports = {
  startTool: startTool,
  pauseTool: pauseTool,
  restartTool: restartTool,
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/gameControl.js